import customAlert from "@/features/ui/alert/Alert";
import { Box, Divider, SimpleGrid, TextInput, Title } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { IncomingInspectionsGetRequest } from "@sizlcorp/sizl-api-document/dist/models";

interface SubBagInputProps {
  disabled?: boolean;
  bagNum: number;
  form: UseFormReturnType<IncomingInspectionsGetRequest>;
}

export const SubBagInputGrid = ({ disabled, bagNum, form }: SubBagInputProps) => {
  const bagBox = Array.from({ length: bagNum }, (_, i) => `${i + 1}`);

  const handleTogglePassed = (index: number) => {
    if (form.values.details?.[index]?.quantity === undefined) {
      return customAlert("값을 입력해주세요.", "실패", "red");
    }

    const currentReturned = form.values.details?.[index]?.isReturned;
    form.setFieldValue(`details.${index}.isReturned`, !currentReturned);
  };

  return (
    <SimpleGrid cols={5} spacing={0}>
      {bagBox.map((bag, index) => (
        <Box
          key={index}
          onClick={() => !disabled && handleTogglePassed(index)}
          sx={(theme) => ({
            border: `1px solid ${theme.colors.gray[4]}`,
            textAlign: "center",

            backgroundColor:
              form.values.details?.[index]?.isReturned !== undefined
                ? form.values.details?.[index]?.isReturned
                  ? theme.colors.red[2]
                  : theme.colors.green[2]
                : undefined,

            cursor: "pointer",
          })}
        >
          <Title order={4}>{bag}</Title>
          <Divider />
          <TextInput
            disabled={disabled}
            type="number"
            onClick={(e) => e.stopPropagation()}
            styles={{
              input: {
                textAlign: "center",
                border: "none",
                background: "inherit",
                fontWeight: "bold",
              },
            }}
            value={form.values.details?.[index]?.quantity}
            placeholder="양품 수량을 입력해주세요"
            onChange={(e) => {
              const value = e.currentTarget.value;
              form.setFieldValue(`details.${index}.quantity`, value === "" ? undefined : value);
              const currentReturned = form.values.details?.[index]?.isReturned;

              if (value === "") {
                form.setFieldValue(`details.${index}.isReturned`, undefined);
              } else if (currentReturned !== true) {
                // 이미 불량 상태가 아니라면 -> 양품으로 간주
                form.setFieldValue(`details.${index}.isReturned`, false);
              }
            }}
          />
        </Box>
      ))}
    </SimpleGrid>
  );
};

export default SubBagInputGrid;
